/* @flow */
import * as React from 'react';

const MyLuggs = props => (
  <svg
    width={22}
    height={20}
    viewBox="0 0 22 20"
    stroke="#505FB4"
    strokeWidth={2}
    fill="none"
    fillRule="evenodd"
    strokeLinecap="round"
    opacity={0.25}
    strokeLinejoin="round"
    {...props}>
    <polyline points="1 2 1 8 7 8" />
    <path d="M3.51,13 C4.842,16.781 8.514,19.225 12.516,18.994 C16.518,18.764 19.885,15.915 20.774,12.006 C21.664,8.098 19.861,4.072 16.353,2.133 C12.845,0.193 8.477,0.808 5.64,3.64 L1,8" />
  </svg>
);

export default MyLuggs;



// WEBPACK FOOTER //
// ./src/assets/images/icons/my-luggs.js